// extracted by mini-css-extract-plugin
module.exports = {"container":"_1c1nC","button":"_3-7dx","right":"_2c8mW","left":"_3OP0h"};